import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Footer } from "../../Components/Footer";

const sections = [
  "§ 1. Postanowienia ogólne",
  "§ 2. Definicje",
  "§ 3. Rodzaje i zakres usług świadczonych drogą elektroniczną",
  "§ 4. Warunki techniczne korzystania z Serwisu",
  "§ 5. Tworzenie i korzystanie z Konta",
  "§ 6. Użytkownicy niepełnoletni",
  "§ 7. Profil Użytkownika",
  "§ 8. CV i udostępnianie informacji",
  "§ 9. Mikropoświadczenia, certyfikaty i efekty uczenia się",
  "§ 10. Raport postępów i doradztwo zawodowe",
  "§ 11. Ścieżki kompetencyjne i kwalifikacje",
  "§ 12. Kreator scenariuszy",
  "§ 13. Grupy i wydarzenia VR",
  "§ 14. Prawa własności intelektualnej",
  "§ 15. Zasady korzystania z Serwisu i zakazane działania",
  "§ 16. Odpowiedzialność Fundacji",
  "§ 17. Ochrona danych osobowych",
  "§ 18. Reklamacje i zgłaszanie problemów",
  "§ 19. Zawieranie i rozwiązywanie umowy o świadczenie usług",
  "§ 20. Zmiany Regulaminu",
  "§ 21. Postanowienia końcowe"
];

const documentStyles = {
  minWidth: 0,
  fontSize: { xs: "15px", sm: "16px" },
  lineHeight: 1.8,
  "& section": {
    scrollMarginTop: "96px",
    py: { xs: 3, md: 4 },
    borderTop: "1px solid #e2e5e7",
  },
  "& h2": {
    mt: 0, mb: 2, color: "#203642",
    fontSize: { xs: "19px", sm: "22px" },
    fontWeight: 600, lineHeight: 1.4, letterSpacing: "-0.015em",
  },
  "& p": { mt: 0, mb: 2 },
  "& ol, & ul": { mt: 0, mb: 2, pl: "1.5em" },
  "& li": { pl: "0.35em", mb: 1 },
  "& li > ul": { mt: 1, mb: 0, listStyleType: "disc" },
  "& section > :last-child": { mb: 0 },
  "& strong": { fontWeight: 600 },
  "& a": {
    color: "#24586b", textDecoration: "underline",
    textUnderlineOffset: "3px", overflowWrap: "anywhere",
    "&:hover": { color: "#142f3a" },
  },
  "@media print": {
    fontSize: "10pt", color: "#000",
    "& section": { py: 2 },
    "& h2": { breakAfter: "avoid" },
  },
};

export const Regulamin = () => (
  <>
    <Box component="main" sx={{
      color: "#39434a", minHeight: "100vh",
      "& a:focus-visible, & summary:focus-visible": {
        outline: "2px solid #24586b", outlineOffset: "4px",
      },
    }}>
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2.5, sm: 4 } }}>
        <Box component="header" sx={{ mb: { xs: 4, md: 6 } }}>
          <Typography component="p" sx={{ mb: 1, fontSize: 14, color: "#647078" }}>
            Micree / Dokumenty
          </Typography>
          <Typography component="h1" sx={{
            m: 0, color: "#203642", fontWeight: 600,
            fontSize: { xs: "32px", sm: "40px", md: "48px" },
            lineHeight: 1.15, letterSpacing: "-0.035em",
          }}>
            Regulamin serwisu internetowego Micree
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "240px minmax(0, 1fr)" }, gap: { xs: 4, md: 7 } }}>
          <Box component="nav" aria-label="Spis treści regulaminu" sx={{
            alignSelf: "start", position: { md: "sticky" }, top: 32,
            maxHeight: { md: "calc(100vh - 64px)" }, overflowY: "auto",
            pr: 1, "@media print": { display: "none" },
          }}>
            <Box component="details" open sx={{
              "& summary": { cursor: "pointer", fontSize: 14, fontWeight: 600, color: "#203642", mb: 2 },
            }}>
              <summary>Spis treści</summary>
              <Box component="ol" sx={{ listStyle: "none", p: 0, m: 0 }}>
                {sections.map((title, index) => (
                  <Box component="li" key={title} sx={{ mb: 0.5 }}>
                    <Box component="a" href={`#paragraf-${index + 1}`} sx={{
                      display: "block", py: 0.6, color: "#56636b",
                      fontSize: 13, lineHeight: 1.55, textDecoration: "none",
                      "&:hover": { color: "#203642", textDecoration: "underline", textUnderlineOffset: "3px" },
                    }}>
                      {title}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>

          <Box component="article" aria-label="Treść regulaminu" sx={documentStyles}>
            <section id="paragraf-1" aria-labelledby="naglowek-1">
              <h2 id="naglowek-1">§ 1. Postanowienia ogólne</h2>
              <ol>
              <li>Niniejszy Regulamin określa zasady korzystania z serwisu internetowego Micree, dostępnego pod adresem <a href="http://www.micree.pl/">www.micree.pl</a>, zwanego dalej „Serwisem”.</li>
              <li>Właścicielem marki Micree oraz podmiotem prowadzącym Serwis jest Fundacja VCC z siedzibą w Lublinie:<ul>
              <li>pełna nazwa: Fundacja VCC;</li>
              <li>adres: ul. Matki Teresy z Kalkuty 18 lok. 16, 20-538 Lublin;</li>
              <li>NIP: 712 32 81 299;</li>
              <li>KRS: 0000479551;</li>
              <li>adres strony internetowej Fundacji: <a href="http://www.vccsystem.eu/">www.vccsystem.eu</a>;</li>
              <li>adres poczty elektronicznej: <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              </ul>
              </li>
              <li>Serwis stanowi internetową część ekosystemu Micree, obejmującego aplikację VR Micree oraz narzędzia wspierające rozwój kompetencji, edukację i orientację zawodową.</li>
              <li>Serwis jest przeznaczony w szczególności dla użytkowników korzystających z aplikacji VR Micree podczas szkoleń, zajęć edukacyjnych, wydarzeń i innych aktywności organizowanych przez Fundację VCC lub współpracujące z nią podmioty.</li>
              <li>Korzystanie z Serwisu jest bezpłatne.</li>
              <li>Regulamin jest udostępniany nieodpłatnie w sposób umożliwiający jego wyświetlenie, pobranie, zapisanie i odtworzenie.</li>
              </ol>
            </section>
            <section id="paragraf-2" aria-labelledby="naglowek-2">
              <h2 id="naglowek-2">§ 2. Definicje</h2>
              <p>Użyte w Regulaminie określenia oznaczają:</p> <ol>
              <li>
              <strong>Fundacja</strong> – Fundacja VCC z siedzibą w Lublinie, właściciel marki Micree i podmiot prowadzący Serwis.</li>
              <li>
              <strong>Micree</strong> – marka Fundacji VCC obejmująca aplikację VR, Serwis oraz powiązane narzędzia i rozwiązania edukacyjne.</li>
              <li>
              <strong>Serwis</strong> – serwis internetowy dostępny pod adresem <a href="http://www.micree.pl/">www.micree.pl</a>.</li>
              <li>
              <strong>Użytkownik</strong> – osoba fizyczna korzystająca z Serwisu, posiadająca konto.</li>
              <li>
              <strong>Konto</strong> – indywidualny profil Użytkownika w Serwisie, powiązany z adresem poczty elektronicznej przypisanym do Użytkownika.</li>
              <li>
              <strong>Aplikacja VR Micree</strong> – aplikacja wykorzystywana do realizacji scenariuszy edukacyjnych i ćwiczeń w środowisku wirtualnej rzeczywistości.</li>
              <li>
              <strong>Mikropoświadczenia</strong> – cyfrowe potwierdzenia osiągnięć, efektów uczenia się lub nabytych kompetencji uzyskanych przez Użytkownika w ramach aktywności Micree.</li>
              <li>
              <strong>Raport postępów</strong> – zestawienie informacji dotyczących postępów Użytkownika, w tym uzyskanych mikropoświadczeń, mocnych stron i obszarów do rozwoju oraz wyników aktywności VR.</li>
              <li>
              <strong>Kreator scenariuszy</strong> – narzędzie umożliwiające tworzenie własnych scenariuszy edukacyjnych, w tym escape roomów lub środowisk z zadaniami, dostępne w aplikacji VR Micree oraz w wersji komputerowej, o ile dana funkcjonalność jest udostępniona.</li>
              <li>
              <strong>Treści Użytkownika</strong> – materiały wprowadzone lub utworzone przez Użytkownika w Serwisie, w szczególności dane profilu, treści CV oraz scenariusze stworzone w Kreatorze.</li>
              <li>
              <strong>Unikalny link</strong> – indywidualny adres internetowy umożliwiający udostępnienie określonych treści, np. CV lub mikropoświadczeń, innym osobom.</li>
              <li>
              <strong>PRK</strong> – Polska Rama Kwalifikacji, której poziomy mogą być prezentowane przy informacjach o kwalifikacjach lub kompetencjach.</li>
              </ol>
            </section>
            <section id="paragraf-3" aria-labelledby="naglowek-3">
              <h2 id="naglowek-3">§ 3. Rodzaje i zakres usług świadczonych drogą elektroniczną</h2>
              <ol>
              <li>Za pośrednictwem Serwisu Fundacja świadczy nieodpłatnie następujące usługi:<ul>
              <li>umożliwienie logowania do Konta;</li>
              <li>udostępnianie profilu Użytkownika;</li>
              <li>prezentowanie informacji o aktywnościach i wynikach uzyskanych w aplikacji VR Micree;</li>
              <li>prezentowanie i pobieranie uzyskanych mikropoświadczeń;</li>
              <li>prezentowanie efektów uczenia się;</li>
              <li>tworzenie, edycję i przechowywanie CV;</li>
              <li>udostępnianie CV i wybranych informacji za pomocą unikalnego linku lub funkcji udostępniania;</li>
              <li>udostępnianie informacji o najczęściej wybieranych kwalifikacjach zawodowych;</li>
              <li>prezentowanie ścieżek kompetencyjnych;</li>
              <li>prezentowanie posiadanych i możliwych do rozwijania umiejętności oraz kwalifikacji;</li>
              <li>prezentowanie informacji o poziomach PRK, jeżeli są przypisane do danej kwalifikacji;</li>
              <li>udostępnianie galerii certyfikatów VCC;</li>
              <li>udostępnianie listy kwalifikacji zawodowych związanych z Zintegrowanym Systemem Kwalifikacji, w zakresie prezentowanym przez Fundację;</li>
              <li>udostępnianie informacji o konkursach i wydarzeniach Micree, w tym MicreeVRcup;</li>
              <li>udostępnianie kalendarza wydarzeń VR oraz informacji o możliwości udziału w wydarzeniach;</li>
              <li>udostępnianie Kreatora scenariuszy;</li>
              <li>udostępnianie raportów postępów i podsumowań rozwoju kompetencji;</li>
              <li>udostępnianie informacji o grupach, do których należy Użytkownik;</li>
              <li>umożliwienie kontaktu z Fundacją w sprawach dotyczących działania Serwisu.</li>
              </ul>
              </li>
              <li>Zakres funkcji dostępnych dla konkretnego Użytkownika może zależeć od jego udziału w szkoleniach, wydarzeniach, grupach lub innych aktywnościach Micree.</li>
              <li>Fundacja może rozwijać, aktualizować, zmieniać lub wycofywać poszczególne funkcje Serwisu, z uwzględnieniem obowiązujących przepisów prawa i praw Użytkowników.</li>
              </ol>
            </section>
            <section id="paragraf-4" aria-labelledby="naglowek-4">
              <h2 id="naglowek-4">§ 4. Warunki techniczne korzystania z Serwisu</h2>
              <ol>
              <li>Do korzystania z Serwisu niezbędne są:<ul>
              <li>urządzenie z dostępem do Internetu;</li>
              <li>aktualna wersja przeglądarki internetowej obsługującej technologie wykorzystywane przez Serwis;</li>
              <li>aktywny adres poczty elektronicznej przypisany do Konta;</li>
              <li>oprogramowanie umożliwiające obsługę plików pobieranych z Serwisu, w tym plików mikropoświadczeń;</li>
              <li>w przypadku korzystania z określonych funkcji Kreatora scenariuszy – urządzenie spełniające wymagania techniczne tej funkcji.</li>
              </ul>
              </li>
              <li>Szczegółowe wymagania techniczne dotyczące aplikacji VR Micree, gogli VR i Kreatora scenariuszy mogą być określone w odrębnych instrukcjach lub komunikatach Fundacji.</li>
              <li>Użytkownik powinien korzystać z urządzeń i oprogramowania w sposób zapewniający bezpieczeństwo własne oraz bezpieczeństwo danych logowania.</li>
              <li>Fundacja nie gwarantuje prawidłowego działania Serwisu na każdym urządzeniu, w każdej przeglądarce i przy każdym rodzaju połączenia internetowego.</li>
              </ol>
            </section>
            <section id="paragraf-5" aria-labelledby="naglowek-5">
              <h2 id="naglowek-5">§ 5. Tworzenie i korzystanie z Konta</h2>
              <ol>
              <li>Konto Użytkownika jest tworzone przez Fundację w związku z udziałem Użytkownika w aktywnościach Micree lub samodzielnie.</li>
              <li>Konto jest przypisywane do adresu poczty elektronicznej podanego w związku z udziałem w szkoleniu, wydarzeniu lub innej aktywności.</li>
              <li>Użytkownik może logować się do Serwisu przy użyciu danych przypisanych do jego Konta.</li>
              <li>Użytkownik zobowiązany jest:<ul>
              <li>podawać prawdziwe i aktualne dane w zakresie wymaganym przez Serwis;</li>
              <li>chronić dane logowania przed dostępem osób nieuprawnionych;</li>
              <li>nie udostępniać danych logowania innym osobom;</li>
              <li>nie korzystać z Konta innej osoby;</li>
              <li>nie podejmować działań mogących zakłócić działanie Serwisu.</li>
              </ul>
              </li>
              <li>W przypadku podejrzenia nieuprawnionego dostępu do Konta Użytkownik powinien niezwłocznie skontaktować się z Fundacją pod adresem <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              <li>Fundacja może ograniczyć lub zablokować dostęp do Konta w przypadku naruszenia Regulaminu, przepisów prawa, bezpieczeństwa Serwisu lub praw innych osób.</li>
              <li>Użytkownik może zgłosić potrzebę usunięcia Konta na adres <a href="mailto:info@micree.pl">info@micree.pl</a>, z zastrzeżeniem obowiązków Fundacji dotyczących przechowywania danych wynikających z przepisów prawa lub innych uzasadnionych podstaw.</li>
              </ol>
            </section>
            <section id="paragraf-6" aria-labelledby="naglowek-6">
              <h2 id="naglowek-6">§ 6. Użytkownicy niepełnoletni</h2>
              <ol>
              <li>Z Serwisu mogą korzystać osoby niepełnoletnie, w szczególności uczniowie szkół ponadpodstawowych, zgodnie z zasadami udziału w danej aktywności Micree.</li>
              <li>Konto Użytkownika niepełnoletniego jest tworzone przez Fundację w związku z udziałem w szkoleniu, wydarzeniu lub innej aktywności.</li>
              <li>Fundacja może wprowadzić dodatkowe zasady korzystania z Serwisu przez osoby niepełnoletnie, jeżeli będzie to wymagane przepisami prawa, charakterem funkcji lub zasadami organizacji szkolenia.</li>
              <li>Użytkownicy niepełnoletni powinni korzystać z Serwisu zgodnie z zasadami bezpieczeństwa przekazanymi przez Fundację, szkołę lub organizatora aktywności.</li>
              </ol>
            </section>
            <section id="paragraf-7" aria-labelledby="naglowek-7">
              <h2 id="naglowek-7">§ 7. Profil Użytkownika</h2>
              <ol>
              <li>W ramach Konta Użytkownik może mieć dostęp do profilu zawierającego w szczególności:<ul>
              <li>adres poczty elektronicznej;</li>
              <li>miasto;</li>
              <li>numer telefonu;</li>
              <li>informacje o wykształceniu;</li>
              <li>inne informacje udostępnione w ramach funkcji Serwisu.</li>
              </ul>
              </li>
              <li>Zakres danych widocznych w profilu może zależeć od konfiguracji Konta oraz funkcji udostępnionych Użytkownikowi.</li>
              <li>Użytkownik powinien dbać o aktualność danych, które samodzielnie wprowadza do profilu.</li>
              <li>Użytkownik nie powinien zamieszczać w profilu danych innych osób bez odpowiedniej podstawy prawnej lub ich zgody, jeżeli jest ona wymagana.</li>
              </ol>
            </section>
            <section id="paragraf-8" aria-labelledby="naglowek-8">
              <h2 id="naglowek-8">§ 8. CV i udostępnianie informacji</h2>
              <ol>
              <li>Serwis umożliwia Użytkownikowi tworzenie, edycję i prezentowanie CV na podstawie danych wprowadzonych przez Użytkownika oraz informacji dostępnych w jego Koncie.</li>
              <li>Użytkownik ponosi odpowiedzialność za prawdziwość, aktualność i zgodność z prawem informacji, które samodzielnie wprowadza do CV.</li>
              <li>CV może zawierać informacje o wykształceniu, umiejętnościach, kwalifikacjach, mikropoświadczeniach, certyfikatach i efektach uczenia się.</li>
              <li>Przed udostępnieniem treści Użytkownik powinien sprawdzić, czy nie zawierają one danych, których nie chce ujawniać osobom trzecim.</li>
              </ol>
            </section>
            <section id="paragraf-9" aria-labelledby="naglowek-9">
              <h2 id="naglowek-9">§ 9. Mikropoświadczenia, certyfikaty i efekty uczenia się</h2>
              <ol>
              <li>Serwis umożliwia Użytkownikowi przeglądanie mikropoświadczeń uzyskanych w związku z aktywnościami Micree.</li>
              <li>Mikropoświadczenia mogą być dostępne do pobrania w formie zaszyfrowanego pliku.</li>
              <li>Serwis może prezentować:<ul>
              <li>nazwę mikropoświadczenia;</li>
              <li>opis potwierdzanych efektów uczenia się;</li>
              <li>datę uzyskania;</li>
              <li>informacje o kompetencjach;</li>
              <li>inne dane związane z osiągnięciem.</li>
              </ul>
              </li>
              <li>Użytkownik może udostępniać mikropoświadczenia lub wybrane informacje:<ul>
              <li>za pomocą unikalnego linku;</li>
              <li>w mediach społecznościowych;</li>
              <li>w inny sposób udostępniony przez Serwis.</li>
              </ul>
              </li>
              <li>Serwis może umożliwiać prezentowanie galerii certyfikatów VCC oraz informacji o kwalifikacjach zawodowych.</li>
              <li>Informacje prezentowane w Serwisie mają charakter informacyjny i edukacyjny. Nie stanowią automatycznie decyzji o przyznaniu kwalifikacji regulowanej ani nie zastępują certyfikatu wydanego przez uprawniony podmiot, jeżeli odrębne przepisy wymagają formalnego potwierdzenia kwalifikacji.</li>
              <li>Użytkownik może zgłosić Fundacji niezgodność danych dotyczących mikropoświadczeń, certyfikatów lub efektów uczenia się, przesyłając wiadomość na adres <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              </ol>
            </section>
            <section id="paragraf-10" aria-labelledby="naglowek-10">
              <h2 id="naglowek-10">§ 10. Raport postępów i doradztwo zawodowe</h2>
              <ol>
              <li>Serwis może udostępniać Użytkownikowi raport postępów opracowany na podstawie aktywności i wyników uzyskanych w aplikacji VR Micree.</li>
              <li>Raport może obejmować:<ul>
              <li>podsumowanie zdobytych mikropoświadczeń;</li>
              <li>informacje o mocnych stronach Użytkownika;</li>
              <li>obszary wymagające dalszego rozwoju;</li>
              <li>wyniki i postępy w rozgrywkach VR;</li>
              <li>porównanie wybranych wyników z wynikami innych Użytkowników;</li>
              <li>propozycje dalszego rozwoju kompetencji;</li>
              <li>informacje o ścieżkach kompetencyjnych;</li>
              <li>inne podsumowania związane z aktywnością Użytkownika.</li>
              </ul>
              </li>
              <li>Raporty mogą wspierać orientację zawodową i planowanie rozwoju kompetencji.</li>
              <li>Raport nie stanowi diagnozy psychologicznej, orzeczenia, gwarancji zatrudnienia ani wiążącej decyzji o predyspozycjach zawodowych Użytkownika.</li>
              <li>Wyniki prezentowane w raporcie mogą zależeć od rodzaju scenariusza, warunków rozgrywki, sposobu wykonania zadań oraz zastosowanych metod analizy.</li>
              <li>Raport jest dostępny wyłącznie dla Użytkownika.</li>
              </ol>
            </section>
            <section id="paragraf-11" aria-labelledby="naglowek-11">
              <h2 id="naglowek-11">§ 11. Ścieżki kompetencyjne i kwalifikacje</h2>
              <ol>
              <li>Serwis może prezentować ścieżki kompetencyjne związane z rozwojem umiejętności i kwalifikacji zawodowych.</li>
              <li>Użytkownik może sprawdzić:<ul>
              <li>posiadane kompetencje i kwalifikacje;</li>
              <li>kompetencje i kwalifikacje możliwe do dalszego rozwijania;</li>
              <li>proponowane kierunki rozwoju;</li>
              <li>informacje o poziomach PRK, jeśli są przypisane do prezentowanych kwalifikacji.</li>
              </ul>
              </li>
              <li>Informacje o kwalifikacjach zawodowych mogą obejmować kwalifikacje związane z Zintegrowanym Systemem Kwalifikacji oraz inne informacje edukacyjne udostępniane przez Fundację.</li>
              <li>Prezentowane ścieżki kompetencyjne mają charakter informacyjny i wspierający rozwój Użytkownika. Nie stanowią indywidualnej, wiążącej porady zawodowej ani gwarancji uzyskania określonej kwalifikacji.</li>
              <li>Fundacja dokłada starań, aby informacje były aktualne, jednak ich dostępność i zakres mogą ulegać zmianom.</li>
              </ol>
            </section>
            <section id="paragraf-12" aria-labelledby="naglowek-12">
              <h2 id="naglowek-12">§ 12. Kreator scenariuszy</h2>
              <ol>
              <li>Serwis oraz aplikacja VR Micree mogą udostępniać Kreator scenariuszy umożliwiający tworzenie własnych scenariuszy edukacyjnych.</li>
              <li>Użytkownik może tworzyć w Kreatorze scenariusze obejmujące w szczególności escape roomy, środowiska i zadania.</li>
              <li>Użytkownik zobowiązuje się korzystać z Kreatora zgodnie z prawem, dobrymi obyczajami i zasadami bezpieczeństwa.</li>
              <li>Zabronione jest tworzenie lub rozpowszechnianie za pośrednictwem Kreatora treści:<ul>
              <li>bezprawnych;</li>
              <li>naruszających prawa autorskie, prawa osobiste lub dobra osobiste innych osób;</li>
              <li>zawierających dane osobowe osób trzecich bez odpowiedniej podstawy prawnej;</li>
              <li>nawołujących do przemocy, nienawiści lub dyskryminacji;</li>
              <li>o charakterze pornograficznym lub wykorzystujących osoby małoletnie w sposób naruszający ich dobro;</li>
              <li>zawierających złośliwe oprogramowanie lub inne elementy zagrażające bezpieczeństwu;</li>
              <li>naruszających bezpieczeństwo, stabilność lub prawidłowe działanie Serwisu.</li>
              </ul>
              </li>
              <li>Użytkownik oświadcza, że posiada prawa lub odpowiednie uprawnienia do materiałów, które wprowadza do Kreatora.</li>
              <li>Fundacja może publikować i udostępniać scenariusze stworzone przez Użytkowników innym osobom, w tym innym Użytkownikom Micree.</li>
              <li>Fundacja VCC może wykorzystywać stworzone scenariusze w celach promocyjnych, szkoleniowych, konkursowych i komercyjnych.</li>
              <li>Fundacja może usunąć lub ograniczyć dostęp do scenariusza, jeżeli uzna, że narusza on Regulamin, przepisy prawa, prawa osób trzecich lub bezpieczeństwo Serwisu.</li>
              <li>Fundacja może wprowadzić procedury zgłaszania naruszeń dotyczących scenariuszy.</li>
              <li>Scenariusze są dostępne wyłącznie dla zalogowanych Użytkowników.</li>
              </ol>
            </section>
            <section id="paragraf-13" aria-labelledby="naglowek-13">
              <h2 id="naglowek-13">§ 13. Grupy i wydarzenia VR</h2>
              <ol>
              <li>Serwis może umożliwiać Użytkownikowi sprawdzenie grup, do których należy w związku z udziałem w aktywnościach Micree.</li>
              <li>Informacje o grupach mogą obejmować nazwę grupy, podstawowe informacje organizacyjne oraz inne dane udostępnione w ramach danej funkcji.</li>
              <li>Serwis może prezentować kalendarz wydarzeń VR, w tym informacje o terminach, zasadach udziału i sposobie zgłoszenia.</li>
              <li>Udział w wydarzeniu może wymagać spełnienia dodatkowych warunków określonych przez Fundację lub organizatora.</li>
              <li>Informacje o konkursach, w tym MicreeVRcup, mają charakter informacyjny, a szczegółowe zasady udziału w konkursach określają odrębne regulaminy.</li>
              <li>Fundacja może zmieniać terminy, zakres lub zasady wydarzeń z przyczyn organizacyjnych, technicznych lub niezależnych od niej.</li>
              </ol>
            </section>
            <section id="paragraf-14" aria-labelledby="naglowek-14">
              <h2 id="naglowek-14">§ 14. Prawa własności intelektualnej</h2>
              <ol>
              <li>Wszelkie prawa do Serwisu, jego układu, funkcjonalności, oprogramowania, elementów graficznych, oznaczeń, logotypów, materiałów edukacyjnych, raportów, baz danych oraz innych elementów udostępnianych przez Fundację, w zakresie przysługującym Fundacji, należą do Fundacji VCC lub podmiotów, które udzieliły jej odpowiednich praw.</li>
              <li>Marka Micree, jej oznaczenia oraz elementy identyfikacji wizualnej podlegają ochronie na zasadach określonych w przepisach prawa.</li>
              <li>Użytkownik może korzystać z treści Serwisu wyłącznie w zakresie dozwolonym przez prawo, Regulamin oraz udzielone uprawnienia.</li>
              <li>Bez uprzedniej zgody Fundacji zabronione jest w szczególności:<ul>
              <li>kopiowanie, rozpowszechnianie lub publiczne udostępnianie elementów Serwisu poza przypadkami dozwolonymi prawem;</li>
              <li>modyfikowanie lub odtwarzanie oprogramowania Serwisu;</li>
              <li>wykorzystywanie oznaczeń Micree lub Fundacji w sposób mogący wprowadzać w błąd co do pochodzenia materiałów;</li>
              <li>wykorzystywanie treści Serwisu w sposób naruszający prawa Fundacji lub osób trzecich.</li>
              </ul>
              </li>
              <li>Prawa do Treści Użytkownika są uregulowane w § 12 Regulaminu oraz w ewentualnych odrębnych warunkach korzystania z Kreatora.</li>
              </ol>
            </section>
            <section id="paragraf-15" aria-labelledby="naglowek-15">
              <h2 id="naglowek-15">§ 15. Zasady korzystania z Serwisu i zakazane działania</h2>
              <ol>
              <li>Użytkownik zobowiązany jest korzystać z Serwisu zgodnie z prawem, Regulaminem, dobrymi obyczajami oraz z poszanowaniem praw innych osób.</li>
              <li>Zabronione jest:<ul>
              <li>dostarczanie treści o charakterze bezprawnym;</li>
              <li>podejmowanie prób uzyskania dostępu do Kont innych osób;</li>
              <li>obchodzenie zabezpieczeń Serwisu;</li>
              <li>ingerowanie w kod, infrastrukturę lub działanie Serwisu;</li>
              <li>podejmowanie działań powodujących nadmierne obciążenie systemów;</li>
              <li>wykorzystywanie Serwisu do rozsyłania spamu, złośliwego oprogramowania lub treści naruszających prawo;</li>
              <li>podawanie się za inną osobę;</li>
              <li>wykorzystywanie danych innych osób bez odpowiedniej podstawy prawnej;</li>
              <li>zamieszczanie treści naruszających dobra osobiste, prawa autorskie lub inne prawa osób trzecich.</li>
              </ul>
              </li>
              <li>Użytkownik ponosi odpowiedzialność za działania podejmowane przy użyciu jego Konta, chyba że wykaże, iż doszło do nich bez jego winy i pomimo zachowania należytej staranności w ochronie danych dostępowych.</li>
              </ol>
            </section>
            <section id="paragraf-16" aria-labelledby="naglowek-16">
              <h2 id="naglowek-16">§ 16. Odpowiedzialność Fundacji</h2>
              <ol>
              <li>Fundacja dokłada należytej staranności, aby Serwis działał prawidłowo, bezpiecznie i zgodnie z opisem jego funkcjonalności.</li>
              <li>Fundacja nie gwarantuje:<ul>
              <li>nieprzerwanej i bezbłędnej dostępności Serwisu;</li>
              <li>zgodności Serwisu z każdym urządzeniem lub oprogramowaniem;</li>
              <li>osiągnięcia przez Użytkownika określonych wyników edukacyjnych lub zawodowych;</li>
              <li>uzyskania zatrudnienia, kwalifikacji lub certyfikatu wyłącznie w wyniku korzystania z Serwisu;</li>
              <li>niezmienności wszystkich funkcjonalności i treści.</li>
              </ul>
              </li>
              <li>Fundacja może czasowo ograniczyć dostęp do Serwisu w związku z konserwacją, aktualizacją, naprawą, awarią, zagrożeniem bezpieczeństwa lub innymi uzasadnionymi przyczynami.</li>
              <li>Fundacja odpowiada za niewykonanie lub nienależyte wykonanie usług na zasadach wynikających z bezwzględnie obowiązujących przepisów prawa.</li>
              <li>Żadne postanowienie Regulaminu nie wyłącza ani nie ogranicza odpowiedzialności Fundacji w zakresie, w jakim takie wyłączenie lub ograniczenie jest niedopuszczalne na mocy prawa.</li>
              </ol>
            </section>
            <section id="paragraf-17" aria-labelledby="naglowek-17">
              <h2 id="naglowek-17">§ 17. Ochrona danych osobowych</h2>
              <ol>
              <li>Administratorem danych osobowych Użytkowników Serwisu jest Fundacja VCC z siedzibą w Lublinie, ul. Matki Teresy z Kalkuty 18 lok. 16, 20-538 Lublin, NIP 712 32 81 299.</li>
              <li>Fundacja przetwarza dane osobowe Użytkowników zgodnie z obowiązującymi przepisami prawa, w szczególności przepisami RODO.</li>
              <li>Szczegółowe informacje dotyczące:<ul>
              <li>celów i podstaw prawnych przetwarzania danych;</li>
              <li>zakresu przetwarzanych danych;</li>
              <li>okresów przechowywania;</li>
              <li>odbiorców danych;</li>
              <li>praw Użytkowników;</li>
              <li>zasad przetwarzania danych osób niepełnoletnich;</li>
              <li>zasad udostępniania CV, mikropoświadczeń i raportów;</li>
              <li>profilowania lub analizy wyników VR;</li>
              <li>plików cookies i podobnych technologii;</li>
              <li>kontaktu w sprawach ochrony danych;</li>
              </ul> zawiera odrębna Polityka prywatności dostępna pod adresem <a href="/polityka-prywatnosci">www.app.micree.pl/polityka-prywatnosci</a>
              </li>
              <li>Korzystanie z Serwisu może wiązać się z przetwarzaniem informacji o aktywności Użytkownika w aplikacji VR Micree, w zakresie opisanym w Polityce prywatności.</li>
              <li>Użytkownik powinien zapoznać się z Polityką prywatności przed rozpoczęciem korzystania z Serwisu.</li>
              </ol>
            </section>
            <section id="paragraf-18" aria-labelledby="naglowek-18">
              <h2 id="naglowek-18">§ 18. Reklamacje i zgłaszanie problemów</h2>
              <ol>
              <li>Użytkownik może zgłaszać reklamacje dotyczące działania Serwisu, Konta lub świadczonych usług.</li>
              <li>Reklamacje należy przesyłać pocztą elektroniczną na adres: <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              <li>Reklamacja powinna w miarę możliwości zawierać:<ul>
              <li>imię i nazwisko lub inne dane umożliwiające identyfikację Konta;</li>
              <li>adres e-mail powiązany z Kontem;</li>
              <li>opis problemu lub niezgodności;</li>
              <li>datę wystąpienia problemu;</li>
              <li>oczekiwany sposób rozwiązania sprawy;</li>
              <li>informacje lub zrzuty ekranu pomocne w rozpatrzeniu zgłoszenia, o ile ich przekazanie jest bezpieczne i nie narusza prywatności innych osób.</li>
              </ul>
              </li>
              <li>Fundacja rozpatruje reklamacje w rozsądnym terminie, z uwzględnieniem charakteru sprawy i obowiązujących przepisów prawa.</li>
              <li>Czas oczekiwania na reklamacje wynosi 14 dni roboczych.</li>
              <li>Odpowiedź na reklamację jest przekazywana na adres poczty elektronicznej, z którego przesłano zgłoszenie, lub na inny adres wskazany przez Użytkownika.</li>
              <li>Zgłoszenia dotyczące ochrony danych osobowych mogą być kierowane na adres <a href="mailto:info@micree.pl">info@micree.pl</a>, z zastrzeżeniem szczegółowych zasad wskazanych w Polityce prywatności.</li>
              </ol>
            </section>
            <section id="paragraf-19" aria-labelledby="naglowek-19">
              <h2 id="naglowek-19">§ 19. Zawieranie i rozwiązywanie umowy o świadczenie usług</h2>
              <ol>
              <li>Rozpoczęcie korzystania z funkcji Serwisu objętych Regulaminem oznacza zawarcie umowy o świadczenie usług drogą elektroniczną na zasadach określonych w Regulaminie, o ile przepisy prawa nie stanowią inaczej.</li>
              <li>Umowa jest zawierana na czas korzystania przez Użytkownika z danej usługi lub do momentu jej rozwiązania zgodnie z Regulaminem.</li>
              <li>Użytkownik może zakończyć korzystanie z Serwisu w dowolnym momencie poprzez wylogowanie się lub zaprzestanie korzystania z Serwisu.</li>
              <li>Użytkownik może zgłosić żądanie usunięcia Konta na adres <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              <li>Fundacja może zakończyć świadczenie danej usługi lub ograniczyć dostęp do Konta na zasadach określonych w Regulaminie, z uwzględnieniem obowiązujących przepisów prawa.</li>
              <li>Usunięcie konta powoduje usunięcie wszystkich danych, scenariuszy, cv, mikropoświadczeń oraz innych informacji.</li>
              </ol>
            </section>
            <section id="paragraf-20" aria-labelledby="naglowek-20">
              <h2 id="naglowek-20">§ 20. Zmiany Regulaminu</h2>
              <ol>
              <li>Fundacja może zmienić Regulamin z ważnych przyczyn, w szczególności w związku z:<ul>
              <li>zmianą przepisów prawa;</li>
              <li>zmianą funkcjonalności Serwisu;</li>
              <li>zmianą sposobu świadczenia usług;</li>
              <li>koniecznością poprawy bezpieczeństwa;</li>
              <li>zmianą danych Fundacji lub danych kontaktowych.</li>
              </ul>
              </li>
              <li>Zmiany Regulaminu są publikowane w Serwisie.</li>
              <li>W przypadku zmian istotnie wpływających na prawa lub obowiązki Użytkownika Fundacja poinformuje o nich w sposób odpowiedni do charakteru zmiany i obowiązujących przepisów prawa.</li>
              </ol>
            </section>
            <section id="paragraf-21" aria-labelledby="naglowek-21">
              <h2 id="naglowek-21">§ 21. Postanowienia końcowe</h2>
              <ol>
              <li>Regulamin podlega prawu polskiemu, z zastrzeżeniem bezwzględnie obowiązujących przepisów prawa chroniących Użytkownika.</li>
              <li>W sprawach nieuregulowanych Regulaminem zastosowanie mają właściwe przepisy prawa polskiego.</li>
              <li>Jeżeli którekolwiek postanowienie Regulaminu okaże się nieważne lub nieskuteczne, pozostałe postanowienia pozostają w mocy, a nieważne postanowienie zostanie zastąpione rozwiązaniem możliwie najbliższym jego celowi, w zakresie dopuszczalnym przez prawo.</li>
              <li>Regulamin jest dostępny w Serwisie pod adresem: <a href="/regulamin">www.app.micree.pl/regulamin</a>
              </li>
              <li>Wszelkie pytania dotyczące korzystania z Serwisu można kierować na adres: <a href="mailto:info@micree.pl">info@micree.pl</a>.</li>
              </ol>
            </section>
          </Box>
        </Box>
      </Container>
    </Box>
    <Footer />
  </>
);

export default Regulamin;
